<script>
    import {YearsList} from '../../store';

    import MonthlyList from './MonthlyList.svelte';

    export let collapseId;
    export let listItemId;
    export let listName;
    export let totalExp;
    export let active;
    export let monthsList;

</script>

<div class="row">
    <div class="col">
        <div class="list-group">
            <button data-toggle="collapse" data-target={`#${listItemId}`} type="button" class:active={active} class="list-group-item list-group-item-action rounded-0 h5 mb-0 d-flex justify-content-between align-items-center list-group-item-primary">
                {listName}
                <span class="badge badge-pill badge-warning">{totalExp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}/-</span>
            </button>
            
            <div class="collapse" class:show={active} id={collapseId}>
                <div class="card card-body rounded-0 py-0 pr-0">

                    <div class="w-100 list-container">
                        {#each monthsList as monthsListItem}

                            <MonthlyList collapseId={monthsListItem.collapseId} listItemId={monthsListItem.collapseId} listName={monthsListItem.name} totalExp={monthsListItem.total} active={monthsListItem.active} daysList={monthsListItem.daysList} />

                        {/each}
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
